/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { onGetClientProductMappingbyId } from "../../Store/Slices/clientProductMappingbyIdSlice";
import { onGetCategoryAll } from "../../Store/Slices/createCategorySlice";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
// import { onProductByIdSubmit } from "../../Store/Slices/productSlice";

const HeaderOptimized = ({ setModalOpen }) => {
  const dispatch = useDispatch();
  const [scroll, setScroll] = useState(false);
  const categoryData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData,
  );

  const categoryAllData = Array.isArray(categoryData)
    ? [...categoryData].sort((a, b) => a.displayOrder - b.displayOrder)
    : [];

  // const clientProductMapping = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer?.data?.[0]?.clientProductMapping
  // );
  const validateLoginTokenData = useSelector(
    (state) => state.validateLoginTokenSliceReducer.data,
  );
  const loginAuthData = useSelector((state) => state.loginAuthReducer);

  // let category = [];
  // categoryAllData?.forEach((categoryData) => {
  //   if (categoryData.displayHeader) {
  //     let data = clientProductMapping?.find(
  //       (productData) => productData.productId === categoryData.supplierBrandId
  //     );
  //     if (data) {
  //       let products = category[categoryData.name]
  //         ? category[categoryData.name]
  //         : [];
  //       products.push(data);
  //       category = {
  //         ...category,
  //         [categoryData.name]: products,
  //       };
  //     }
  //   }
  // });
  const category = categoryAllData?.reduce((acc, categoryData) => {
    if (categoryData.displayHeader) {
      acc[categoryData.name] = categoryData;
    }
    return acc;
  }, {});

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 200);
    });
    if (loginAuthData?.data?.[0]?.token) {
      // dispatch(onGetClientProductMappingbyId(sessionStorage.getItem("clientCode")));
      dispatch(onGetCategoryAll());
      // dispatch(onProductByIdSubmit(sessionStorage.getItem("clientCode")));
    }
  }, []);

  const getInitials = (firstName = "", lastName = "") => {
    const firstLetter = firstName?.charAt(0) || "";
    const lastLetter = lastName?.charAt(0) || "";
    return `${firstLetter}${lastLetter}`.toUpperCase();
  };

  return (
    <div className="horz-move-fix">
      <DesktopHeader
        scroll={scroll}
        matchCategory={category}
        validateLoginTokenData={validateLoginTokenData}
        getInitials={getInitials}
      />
      <MobileHeader
        scroll={scroll}
        matchCategory={category}
        validateLoginTokenData={validateLoginTokenData}
        getInitials={getInitials}
        setModalOpen={setModalOpen}
      />
    </div>
  );
};

export default HeaderOptimized;
/* eslint-enable react-hooks/exhaustive-deps */
